var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
// External Components
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/styles";
import { useMediaQuery } from "@mui/material";
// Icons
import AccountCircleIcon from "@mui/icons-material/AccountCircleRounded";
// Internal Components
import Sidebar from "./Sidebar";
import AccountInfoButton from "./account/InfoButton";
import AccountSelect from "./AccountSelect";
var useStyles = makeStyles(function (_a) {
    var _b = _a.typography, h1 = _b.h1, pxToRem = _b.pxToRem;
    return ({
        logo: __assign(__assign({}, h1), { "&::after": {
                fontSize: pxToRem(12),
                verticalAlign: "text-top",
                content: '"\u00ae"',
            } }),
        root: {
            justifyContent: "space-between",
        },
    });
});
export default (function (_a) {
    var menuItems = _a.menuItems, handleAccountChange = _a.handleAccountChange, accountValue = _a.accountValue, email = _a.email, accountItems = _a.accountItems, showAccountSelect = _a.showAccountSelect;
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var breakpoints = useTheme().breakpoints;
    var isDownMd = useMediaQuery(breakpoints.down("md"));
    var isUpMd = useMediaQuery(breakpoints.up("md"));
    var handleExpandClick = function () {
        setExpanded(!expanded);
    };
    var classes = useStyles();
    return (React.createElement(AppBar, { position: "static", color: "primary", elevation: 0 },
        React.createElement(Toolbar, { variant: "dense", classes: { root: classes.root } },
            React.createElement(Box, { display: "flex", alignItems: "center" },
                menuItems && React.createElement(Sidebar, { menuItems: menuItems }),
                React.createElement(Typography, { variant: "h1" }, "VERIFI"),
                React.createElement("div", { className: classes.logo })),
            isUpMd && (React.createElement(Box, { display: "flex", alignItems: "center" },
                showAccountSelect && (React.createElement(AccountSelect, { onChange: handleAccountChange, value: accountValue })),
                React.createElement(AccountInfoButton, { email: email }, accountItems))),
            isDownMd && (React.createElement(AccountCircleIcon, { "aria-label": "Show user menu", onClick: handleExpandClick }))),
        isDownMd && (React.createElement(Collapse, { in: expanded, timeout: "auto", unmountOnExit: true },
            React.createElement(Box, { display: "flex", padding: 1 },
                showAccountSelect && (React.createElement(AccountSelect, { onChange: handleAccountChange, value: accountValue })),
                React.createElement(Box, { display: "flex", flex: 1, justifyContent: "flex-end" },
                    React.createElement(AccountInfoButton, { email: email }, accountItems)))))));
});
//# sourceMappingURL=index.js.map